import Action from 'actions';
import {PositionInLineup} from 'helpers/lineup-helper';
import BaseLineup from 'services/sports/default/base-lineup';
import {sortByProperty} from 'helpers/sorters';
import Const from 'constants';

export default class LineupClassic extends BaseLineup {
    // setPlayersByColumns({incomingValues: {team, lineupId}}) {
    //     const state = Action.getState();
    //     const {sportConfig} = state;

    //     const functions = this.exec('getFunctionsToSetPlayersByColumns', {lineupId}, {});

    //     functions.getPriorityPlayerToSetOnPositionIfExists = function (matrix) {
    //         const players = Object.values(matrix.players);
    //         players.sort(sortByProperty('positionAliasesQuantity'));

    //         const {positionAliasesQuantity} = players[0];

    //         if (positionAliasesQuantity > 1) {
    //             for (const player of players) {
    //                 const duplicates = arrayDuplicates(player.positionAliases, ['C', 'PF']);

    //                 if (duplicates.length === 2) {
    //                     return {...player};
    //                 }
    //             }
    //         }

    //         return {};
    //     };

    //     const params = {
    //         team,
    //         sportConfig,
    //         functions,
    //     };

    //     const players = PositionInLineup.set.inDependenceOnDistribution(params);

    //     return [...players];
    // }

    setPlayersByColumns({incomingValues: {team, lineupId}}) {
        const {sportConfig} = Action.getState();
        const positionsOrder = sportConfig.getConfigProp('positionsOrder', {});

        const order1 = ['PG', 'SG', 'SF', 'PF', 'C', 'G/F', 'F/C', 'flex_1', 'flex_2'];
        const order2 = ['PG', 'SG', 'SF', 'PF', 'C', 'F/C', 'G/F', 'flex_1', 'flex_2'];

        const sortObjectsByOrder = (objects, propName,order) => {
            return Object.values(objects).sort((a, b) => order.indexOf(a[propName]) - order.indexOf(b[propName]));
        };

        const params = {
            team,
            positionsOrder: sortObjectsByOrder(positionsOrder, 'id', order1),
            functions: this.exec('getFunctionsToSetPlayersByColumns', {lineupId}, {}),
        };

        let players = PositionInLineup.set.inDependenceOnOrder(params);

        if (isEmpty(players)) {
            params.positionsOrder = sortObjectsByOrder(positionsOrder, 'id', order2);
            players = PositionInLineup.set.inDependenceOnOrder(params);
            players = sortObjectsByOrder(players, 'positionIdInLineup', order1);
        }

        if (isEmpty(players)) {
            return [];
        }

        if (sportConfig.isModeLateswap()) {
            return [...players];
        }

        const groupPlayersByPosition = (players) => {
            const result = {};
            players.map((player) => player.positionShortNames.map((positionName) => {
                result[positionName] ??= [];
                result[positionName].push(player);
            }));

            return result;
        };

        const changePositionIfNeeded = (player) => {
            let positionName = player.positionName;

            if (inArray(player.positionInLineup, ['C', 'PF', 'PG', 'SF', 'SG'])) {
                positionName = player.positionInLineup;
            } else if (inArray(player.positionInLineup, ['G/F', 'F/C'])) {
                const map = {
                    'G/F': ['PF', 'SF', 'PG', 'SG'],
                    'F/C': ['PF', 'SF', 'C'],
                };

                [positionName = player.positionName] = arrayDuplicates(player.positionShortNames, map[player.positionInLineup]);
            }

            player.position = sportConfig.getPositionNumberByName(positionName);
            player.positionName = positionName;
        };

        for (let i = 0; i < 2; i++) {
            players = this.exec('forcePlayerToFlexPosition', {
                lineupPlayers: players,
                flexPositionNames: [Const.POSITION_UTIL],
                getSubstitutablePositionNames: (fromPlayer) => fromPlayer.positionShortNames,
                isPlayerSubstitutable: (toPlayer, fromPlayer, gamesIndexedByTeamName) => {
                    const toPlayerGame = gamesIndexedByTeamName[toPlayer.team];
                    const fromPlayerGame = gamesIndexedByTeamName[fromPlayer.team];
                    const map = {
                        'G/F': ['PF', 'SF', 'PG', 'SG'],
                        'F/C': ['PF', 'SF', 'C'],
                    };

                    return arrayDuplicates(fromPlayer.positionShortNames, map[toPlayer.positionInLineup] ?? [toPlayer.positionInLineup]).length
                        && (toPlayerGame.gameTimestamp > fromPlayerGame.gameTimestamp || toPlayer.salary > fromPlayer.salary);
                },
                groupPlayersByPosition,
                changePositionIfNeeded,
            });
        }

        for (let i = 0; i < 2; i++) {
            players = this.exec('forcePlayerToFlexPosition', {
                lineupPlayers: players,
                flexPositionNames: [Const.NBA_DK_POSITION_GF, Const.NBA_DK_POSITION_FC],
                getSubstitutablePositionNames: (fromPlayer) => fromPlayer.positionShortNames,
                isPlayerSubstitutable: (toPlayer, fromPlayer, gamesIndexedByTeamName) => {
                    const toPlayerGame = gamesIndexedByTeamName[toPlayer.team];
                    const fromPlayerGame = gamesIndexedByTeamName[fromPlayer.team];
                    const map = {
                        'G/F': ['PF', 'SF', 'PG', 'SG'],
                        'F/C': ['PF', 'SF', 'C'],
                    };

                    return fromPlayer.positionShortNames.includes(toPlayer.positionInLineup)
                        && arrayDuplicates(toPlayer.positionShortNames, map[fromPlayer.positionInLineup]).length
                        && (toPlayerGame.gameTimestamp > fromPlayerGame.gameTimestamp || toPlayer.salary > fromPlayer.salary);
                },
                groupPlayersByPosition,
                changePositionIfNeeded,
            });
        }

        return [...players];
    }
}
